<template>
    <section>
        <loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>

        <div class="row">
            <div class="col s12">

                <ul id="tabs-avaliacao" class="tabs">
                    <li class="tab"
                        v-for="(grupo, grupo_i) in grupos"
                        :key="grupo_i">
                        <a :class="{'active' : grupo_i === 0}" :href="`#${grupo_i}`">{{
                                grupo.descricao
                                                                                     }}
                        </a>
                    </li>

                    <li class="tab">
                        <a href="#geral">Conclusão</a>
                    </li>
                </ul>

                <div v-for="(grupo, grupo_i) in grupos"
                     :key="grupo_i"
                     :id="grupo_i"
                     class="col s12">

                    <div class="row">

                        <div class="col s12">

                            <div class="card-panel">

                                <div class="row" v-if="grupo.id === 8">
                                    <h5 class="col s12">Itens da inscrição</h5>

                                    <!-- ITENS CONFIGURÁVEIS DA INSCRIÇÃO -->
                                    <div class="col s12">
                                        <div class="row"
                                             v-for="(item, item_i) in listaItensParaAvaliacaoDosItensPreConfiguradosDaInscricaoEDoGrupoAvaliacaoDaAcao"
                                             :key="item_i">

                                            <div class="col s12 blue-grey lighten-5"
                                                 v-if="verificaSeItemDaAcaoEstaMarcadoParaPreencher(item.item_id)">
                                                <p>
                                                    <i class="material-icons yellow-text text-darken-3 left">warning</i>
                                                    <span style="font-weight: bold;">Aviso!</span>
                                                    <span> Informe a justificativa para a nota que foi dada a esse item! (<strong>{{
                                                            item.nome
                                                                                                                                  }}</strong>)</span>
                                                </p>
                                            </div>

                                            <div class="col s12">
                                                <div class="card-panel"
                                                     :class="{'justificativaNaoPreenchida' : verificaSeItemDaAcaoEstaMarcadoParaPreencher(item.item_id)}">
                                                    <div class="row">
                                                        <strong class="col s12">Item {{ item_i + 1 }}: {{
                                                                item.nome
                                                                                }}
                                                        </strong>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col m6 s12"
                                                             v-if="selecionaItemDaInscricao(item).tipo_item === 'resposta'">
                                                            <div class="row">
                                                                <span class="col s12">Resposta do proponente</span>

                                                                <div class="col s12">
                                                                    <textarea style="width: 100%; min-height: 250px;"
                                                                              disabled
                                                                              :id="`item_config_${item_i}_resposta`"
                                                                              :value="retornaRespostaDoItemDaInscricao(item)"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col m6 s12" v-else>
                                                            <div class="row">
                                                                <span class="col s12">Resposta do proponente</span>

                                                                <div class="col s12">
                                                                    <div style="display: inline;">
                                                                        &nbsp;

                                                                        <a class="btn-flat blue-text"
                                                                           style="display: contents;"
                                                                           :download="retornaAnexoDeItemDaInscricao(item).nome_anexo"
                                                                           :href="linkParaDownload(retornaAnexoDeItemDaInscricao(item))">
                                                                            <i class="material-icons left">
                                                                                file_download
                                                                            </i>
                                                                            {{
                                                                                retornaAnexoDeItemDaInscricao(item).nome_anexo
                                                                            }}
                                                                        </a>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col m6 s12">
                                                            <div class="row">
                                                                <div class="input-field col s12">
                                                                    <input type="number"
                                                                           @change.prevent="validaCampo(item, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max)"
                                                                           onkeydown="return false"
                                                                           class="notas"
                                                                           :id="`item_config_${item_i}_nota`"
                                                                           :ref="`item_config_${item_i}_nota`"
                                                                           :min="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min"
                                                                           :max="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max"
                                                                           :step="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_var"
                                                                           :readonly="item.nome=='Relatório da ação extraído do SIGA' && avaliacao.inscricao.analise_tecnica.item_relatorio_acao_siga=='nao_se_aplica'"
																		   v-model="item.nota">
                                                                    <label :for="`item_config_${item_i}_nota`">Nota
                                                                    </label>
                                                                    <span class="label-info-baixo-destaque">Nota mínima: {{
                                                                            retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min
                                                                                                            }} | Nota máxima: {{
                                                                            retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max
                                                                                                            }}</span>
                                                                </div>

                                                                <div class="col s12">
                                                                    <strong>Justificativa da nota</strong>

                                                                    <textarea style="width: 100%; min-height: 150px;"
                                                                              :id="`item_config_${item_i}_justificativa`"
                                                                              :maxlength="configuracao_avaliacao.quantidade_caracteres_justificativa"
                                                                              v-model="item.justificativa"
                                                                              class="browser-default"
																			  :readonly="item.nome=='Relatório da ação extraído do SIGA' && avaliacao.inscricao.analise_tecnica.item_relatorio_acao_siga=='nao_se_aplica'"></textarea>

                                                                    <span class="right" style="font-size: small;">{{
                                                                            !item.justificativa ? 0 : item.justificativa.length
                                                                                                                  }}/{{
                                                                            configuracao_avaliacao.quantidade_caracteres_justificativa
                                                                                                                  }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- ITENS FIXOS DA INSCRIÇÃO -->
                                    <div class="col s12">
                                        <div class="row"
                                             v-for="(item, item_i) in listaItensFixosDaInscricao"
                                             :key="item_i">

                                            <div class="col s12 blue-grey lighten-5"
                                                 v-if="verificaSeItemDaAcaoEstaMarcadoParaPreencher(item.item_id)">
                                                <p>
                                                    <i class="material-icons yellow-text text-darken-3 left">warning</i>
                                                    <span style="font-weight: bold;">Aviso!</span>
                                                    <span> Informe a justificativa para a nota que foi dada a esse item! (<strong>{{
                                                            item.nome
                                                                                                                                  }}</strong>)</span>
                                                </p>
                                            </div>

                                            <!-- ATUAÇÃO EM TERRITÓRIOS E OU JUNTO A GRUPOS VULNERÁVEIS -->
                                            <div class="col s12"
                                                 v-if="item.campo_referente_na_inscricao === 'acao_atgv'">
                                                <div class="card-panel"
                                                     :class="{'justificativaNaoPreenchida' : verificaSeItemDaAcaoEstaMarcadoParaPreencher(item.item_id)}">
                                                    <div class="row">
                                                        <strong class="col s12">Ação atua em territórios e/ou junto aos
                                                                                grupos vulneráveis?
                                                        </strong>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col s12">
                                                            <span>Resposta do proponente:</span>
                                                            &nbsp;
                                                            <strong class="indigo-text">
                                                                {{ avaliacao.inscricao.acao_atgv ? 'Sim' : 'Não' }}
                                                            </strong>
                                                        </div>
                                                    </div>

                                                    <div class="row" v-if="avaliacao.inscricao.acao_atgv">
                                                        <div class="col s12">
                                                            <ul class="browser-default">
                                                                <li v-for="(atuacao, atuacao_i) in avaliacao.inscricao.lista_de_atuacoes"
                                                                    :key="atuacao_i">
                                                                    <span>{{ atuacao.nome }}</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="input-field col s12">
                                                            <input type="number"
                                                                   :disabled="!avaliacao.inscricao.acao_atgv"
                                                                   onkeydown="return false"
                                                                   class="notas"
                                                                   @change.prevent="validaCampo(item, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max)"
                                                                   :id="`item_fixo_${item_i}_nota`"
                                                                   :ref="`item_fixo_${item_i}_nota`"
                                                                   :min="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min"
                                                                   :max="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max"
                                                                   :step="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_var"
                                                                   v-model="item.nota">
                                                            <label :for="`item_fixo_${item_i}_nota`">Nota</label>
                                                            <span class="label-info-baixo-destaque">Nota mínima: {{
                                                                    retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min
                                                                                                    }} | Nota máxima: {{
                                                                    retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max
                                                                                                    }}</span>
                                                        </div>

                                                        <div class="col s12">
                                                            <strong>Justificativa da nota</strong>

                                                            <textarea style="width: 100%; min-height: 150px;"
                                                                      :id="`item_fixo_${item_i}_justificativa`"
                                                                      :disabled="!avaliacao.inscricao.acao_atgv"
                                                                      :maxlength="configuracao_avaliacao.quantidade_caracteres_justificativa"
                                                                      v-model="item.justificativa"
                                                                      class="browser-default"></textarea>

                                                            <span class="right" style="font-size: small;">{{
                                                                    !item.justificativa ? 0 : item.justificativa.length
                                                                                                          }}/{{
                                                                    configuracao_avaliacao.quantidade_caracteres_justificativa
                                                                                                          }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

											<!-- AÇÕES AFIRMATIVAS -->
                                            <div class="col s12"
                                                 v-if="item.campo_referente_na_inscricao === 'acao_afirmativa'">
                                                <div class="card-panel"
                                                     :class="{'justificativaNaoPreenchida' : verificaSeItemDaAcaoEstaMarcadoParaPreencher(item.item_id)}">
                                                    <div class="row">
                                                        <strong class="col s12">
															<p>Ação responde a alguma política de ação afirmativa voltada para grupos de indivíduos constituídos por pessoas:</p>
															<ul>
																<li>- pretas e pardas;</li>
																<li>- indígenas;</li>
																<li>- quilombolas;</li>
																<li>- com deficiência;</li>
																<li>- com transtorno global do desenvolvimento;</li>
																<li>- transsexuais/transgêneros, travestis e não binários, ou</li>
																<li>- estudantes em atividade parental, identidades femininas e cuidadoras de idosos.</li>
															</ul>
														</strong>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col s12">
                                                            <span>Resposta do proponente:</span>
                                                            &nbsp;
                                                            <strong class="indigo-text">
                                                                {{ avaliacao.inscricao.acao_afirmativa ? 'Sim' : 'Não' }}
                                                            </strong>
                                                        </div>
                                                    </div>

                                                    <div class="row" v-if="avaliacao.inscricao.acao_afirmativa">
                                                        <div class="col s12">
															<textarea style="width: 100%; min-height: 150px;" name="descAcaoAfirmativa"
																		  id="descAcaoAfirmativa"
																		  maxlength="2000"
																		  disabled
																		  v-model="avaliacao.inscricao.desc_acao_afirmativa"
																		  cols="30" rows="10"
																		  class="browser-default">
															</textarea>            
														</div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="input-field col s12">
                                                            <input type="number"
                                                                   :disabled="!avaliacao.inscricao.acao_afirmativa"
                                                                   onkeydown="return false"
                                                                   class="notas"
                                                                   @change.prevent="validaCampo(item, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max)"
                                                                   :id="`item_fixo_${item_i}_nota`"
                                                                   :ref="`item_fixo_${item_i}_nota`"
                                                                   :min="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min"
                                                                   :max="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max"
                                                                   :step="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_var"
                                                                   v-model="item.nota">
                                                            <label :for="`item_fixo_${item_i}_nota`">Nota</label>
                                                            <span class="label-info-baixo-destaque">Nota mínima: {{
                                                                    retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min
                                                                                                    }} | Nota máxima: {{
                                                                    retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max
                                                                                                    }}</span>
                                                        </div>

                                                        <div class="col s12">
                                                            <strong>Justificativa da nota</strong>

                                                            <textarea style="width: 100%; min-height: 150px;"
                                                                      :id="`item_fixo_${item_i}_justificativa`"
                                                                      :disabled="!avaliacao.inscricao.acao_afirmativa"
                                                                      :maxlength="configuracao_avaliacao.quantidade_caracteres_justificativa"
                                                                      v-model="item.justificativa"
                                                                      class="browser-default"></textarea>

                                                            <span class="right" style="font-size: small;">{{
                                                                    !item.justificativa ? 0 : item.justificativa.length
                                                                                                          }}/{{
                                                                    configuracao_avaliacao.quantidade_caracteres_justificativa
                                                                                                          }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
											
											<!-- POLÍTICAS PÚBICAS -->
                                            <div class="col s12"
                                                 v-if="(avaliacao.inscricao.acao.modalidade == 'Programa' || avaliacao.inscricao.acao.modalidade == 'Projeto') && item.campo_referente_na_inscricao === 'acao_politicas_publicas'">
                                                <div class="card-panel"
                                                     :class="{'justificativaNaoPreenchida' : verificaSeItemDaAcaoEstaMarcadoParaPreencher(item.item_id)}">
                                                    <div class="row">
                                                        <strong class="col s12">
															<p>Ação responde a alguma política pública</p>							
														</strong>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col s12">
                                                            <span>Resposta do proponente:</span>
                                                            &nbsp;
                                                            <strong class="indigo-text">
                                                                {{ avaliacao.inscricao.acao_politicas_publicas? 'Sim' : 'Não' }}
                                                            </strong>
                                                        </div>
                                                    </div>

                                                    <div class="row" v-if="avaliacao.inscricao.acao_politicas_publicas">
                                                        <div class="col s12">
															<textarea style="width: 100%; min-height: 150px;" name="descAcaoPoliticasPublicas"
																		  id="descAcaoPoliticasPublicas"
																		  maxlength="2000"
																		  disabled
																		  v-model="avaliacao.inscricao.desc_acao_politicas_publicas"
																		  cols="30" rows="10"
																		  class="browser-default">
															</textarea>            
														</div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="input-field col s12">
                                                            <input type="number"
                                                                   :disabled="!avaliacao.inscricao.acao_politicas_publicas"
                                                                   onkeydown="return false"
                                                                   class="notas"
                                                                   @change.prevent="validaCampo(item, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max)"
                                                                   :id="`item_fixo_${item_i}_nota`"
                                                                   :ref="`item_fixo_${item_i}_nota`"
                                                                   :min="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min"
                                                                   :max="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max"
                                                                   :step="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_var"
                                                                   v-model="item.nota">
                                                            <label :for="`item_fixo_${item_i}_nota`">Nota</label>
                                                            <span class="label-info-baixo-destaque">Nota mínima: {{
                                                                    retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min
                                                                                                    }} | Nota máxima: {{
                                                                    retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max
                                                                                                    }}</span>
                                                        </div>

                                                        <div class="col s12">
                                                            <strong>Justificativa da nota</strong>

                                                            <textarea style="width: 100%; min-height: 150px;"
                                                                      :id="`item_fixo_${item_i}_justificativa`"
                                                                      :disabled="!avaliacao.inscricao.acao_politicas_publicas"
                                                                      :maxlength="configuracao_avaliacao.quantidade_caracteres_justificativa"
                                                                      v-model="item.justificativa"
                                                                      class="browser-default"></textarea>

                                                            <span class="right" style="font-size: small;">{{
                                                                    !item.justificativa ? 0 : item.justificativa.length
                                                                                                          }}/{{
                                                                    configuracao_avaliacao.quantidade_caracteres_justificativa
                                                                                                          }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- CRONOGRAMA DE ATIVIDADES -->
                                            <div class="col s12"
                                                 v-if="item.campo_referente_na_inscricao === 'cronograma_de_atividades'">
                                                <div class="card-panel"
                                                     :class="{'justificativaNaoPreenchida' : verificaSeItemDaAcaoEstaMarcadoParaPreencher(item.item_id)}">
                                                    <div class="row">
                                                        <strong class="col s12">Cronograma de atividades</strong>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col m6 s12">
                                                            <div class="row">
                                                                <span class="col s12">Resposta do proponente</span>

                                                                <div class="col s12">
                                                                    <ul class="browser-default">
                                                                        <li v-for="(tarefa, i) in avaliacao.inscricao.cronograma_de_atividades"
                                                                            :key="i">
                                                                            <div>
                                                                                <p class="badge">
                                                                                    <strong>Data de início:</strong>
                                                                                    {{
                                                                                        formatarData(tarefa.start_date)
                                                                                    }}
                                                                                </p>
                                                                                <p class="badge">
                                                                                    <strong>Duração em meses:</strong>
                                                                                    {{ tarefa.mes }}
                                                                                </p>
                                                                                <p>
                                                                                    <strong>Descrição da tarefa:
                                                                                    </strong>
                                                                                    {{ tarefa.atividades }}
                                                                                </p>&nbsp;
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col m6 s12">
                                                            <div class="row">
                                                                <div class="input-field col s12">
                                                                    <input type="number"
                                                                           onkeydown="return false"
                                                                           class="notas"
                                                                           @change.prevent="validaCampo(item, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min, retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max)"
                                                                           :id="`item_fixo_${item_i}_nota`"
                                                                           :ref="`item_fixo_${item_i}_nota`"
                                                                           :min="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min"
                                                                           :max="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max"
                                                                           :step="retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_var"
                                                                           v-model="item.nota">
                                                                    <label :for="`item_fixo_${item_i}_nota`">Nota
                                                                    </label>
                                                                    <span class="label-info-baixo-destaque">Nota mínima: {{
                                                                            retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_min
                                                                                                            }} | Nota máxima: {{
                                                                            retornaItemDaConfiguracaoDeAcordoComId(item.item_id).nota_max
                                                                                                            }}</span>
                                                                </div>

                                                                <div class="col s12">
                                                                    <strong>Justificativa da nota</strong>

                                                                    <textarea style="width: 100%; min-height: 150px;"
                                                                              :id="`item_fixo_${item_i}_justificativa`"
                                                                              :maxlength="configuracao_avaliacao.quantidade_caracteres_justificativa"
                                                                              v-model="item.justificativa"
                                                                              class="browser-default"></textarea>

                                                                    <span class="right" style="font-size: small;">{{
                                                                            !item.justificativa ? 0 : item.justificativa.length
                                                                                                                  }}/{{
                                                                            configuracao_avaliacao.quantidade_caracteres_justificativa
                                                                                                                  }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
											
											<!-- QUANTITATIVO DE PÚBLICO DO EVENTO (foi o jeito de colocar o quantitativo junto do calendário) -->
                                            <div class="col s12"
                                                 v-if="item.campo_referente_na_inscricao === 'cronograma_de_atividades' && avaliacao.inscricao.acao.modalidade == 'Evento'">
                                                <div class="card-panel">
                                                    <div class="row">
                                                        <strong class="col s12">Quantitativo de público externo atendido</strong>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col m6 s12">
                                                            <div class="row">
                                                                <span class="col s12">Resposta do proponente</span>

                                                                <div class="col s12">
                                                                    {{eventoQtdos[avaliacao.inscricao.evento_qtdo][0]}}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col m6 s12">
                                                            <div class="row">
                                                                <div class="input-field col s12">
                                                                    <input type="number"
                                                                           class="notas"
                                                                           readonly
                                                                           v-model="eventoQtdos[avaliacao.inscricao.evento_qtdo][1]">
                                                                    <label>Nota
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
											
                                        </div>
                                    </div>
                                </div>


                                <!-- ITENS DO PLANO DE TRABALHO -->
                                <div class="row" v-if="grupo.id === 9">
                                    <h5 class="col s12">Itens do plano de trabalho</h5>

                                    <div class="col s12">
                                        <div class="row">
                                            <div class="col s12">
                                                <span>Repetiu o mesmo plano de trabalho para mais de um bolsista?</span>
                                                &nbsp;
                                                <strong class="indigo-text">
                                                    {{ avaliacao.inscricao.repetiu_pdt_bolsista ? 'Sim' : 'Não' }}
                                                </strong>
                                            </div>
                                        </div>

                                        <div class="row" v-if="avaliacao.inscricao.repetiu_pdt_bolsista">
                                            <div class="col s12">
                                                <strong>Justificativa do proponente</strong>

                                                <textarea style="width: 100%; min-height: 150px;"
                                                          disabled
                                                          v-model="avaliacao.inscricao.repetiu_pdt_bolsista_justificativa"
                                                          class="browser-default"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col s12">
                                        <div class="row"
                                             v-for="(pdt, pdt_i) in listaPlanosDeTrabalhoParaAvaliacao"
                                             :key="pdt_i">

                                            <div class="col s12">
                                                <div class="card-panel">
                                                    <div class="row">
                                                        <strong class="col s12">{{
                                                                avaliacao.inscricao.repetiu_pdt_bolsista ? 'Plano de Trabalho ' + (pdt_i + 1) : 'Plano de Trabalho ' + (pdt_i + 1)
                                                                                }}
                                                        </strong>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col s12">
                                                            <div class="row"
                                                                 v-for="(pdt_item, pdt_item_i) in pdt.itens">
                                                                <div class="col s12 blue-grey lighten-5"
                                                                     v-if="verificaSeItemDoPdtEstaMarcadoParaPreencher(pdt.pdt_id, pdt_item.item_id)">
                                                                    <p>
                                                                        <i class="material-icons yellow-text text-darken-3 left">
                                                                            warning
                                                                        </i>
                                                                        <span style="font-weight: bold;">Aviso!</span>
                                                                        <span> Informe a justificativa para a nota que foi dada a esse item! (<strong>{{
                                                                                pdt_item.label
                                                                                                                                                      }}</strong>) do <strong>{{
                                                                                avaliacao.inscricao.repetiu_pdt_bolsista ? 'Plano de Trabalho' : 'Plano de Trabalho ' + (pdt_i + 1)
                                                                                                                                                                              }}</strong></span>
                                                                    </p>
                                                                </div>

                                                                <div class="col s12">
                                                                    <div class="row"
                                                                         :class="{'justificativaNaoPreenchida' : verificaSeItemDoPdtEstaMarcadoParaPreencher(pdt.pdt_id, pdt_item.item_id)}">
                                                                        <strong class="col s12">{{
                                                                                pdt_item.nome
                                                                                                }}
                                                                        </strong>
                                                                        <div class="input-field col s12">
                                                                            <label style="font-size:24px;"
                                                                                   :for="`item_pdt_${pdt_item_i}_${pdt_i}_resposta`">
                                                                                Resposta do proponente
                                                                            </label>
                                                                            <br>
                                                                            <textarea
                                                                                style="width: 100%; min-height: 150px;"
                                                                                disabled
                                                                                :id="`item_pdt_${pdt_item_i}_${pdt_i}_resposta`"
                                                                                :value="retornaRespostaDoItemDaInscricao(pdt_item, 9, pdt.pdt_id)"
                                                                                cols="30" rows="10"
                                                                                class="browser-default"></textarea>

                                                                        </div>

                                                                        <div class="input-field col s12">
                                                                            <input type="number"
                                                                                   onkeydown="return false"
                                                                                   class="notas"
                                                                                   @change.prevent="validaCampo(pdt_item, retornaItemDaConfiguracaoDeAcordoComId(pdt_item.item_id).nota_min, retornaItemDaConfiguracaoDeAcordoComId(pdt_item.item_id).nota_max)"
                                                                                   :id="`item_pdt_${pdt_item_i}_${pdt_i}_nota`"
                                                                                   :ref="`item_pdt_${pdt_item_i}_${pdt_i}_nota`"
                                                                                   :min="retornaItemDaConfiguracaoDeAcordoComId(pdt_item.item_id).nota_min"
                                                                                   :max="retornaItemDaConfiguracaoDeAcordoComId(pdt_item.item_id).nota_max"
                                                                                   :step="retornaItemDaConfiguracaoDeAcordoComId(pdt_item.item_id).nota_var"
                                                                                   v-model="pdt_item.nota">
                                                                            <label style="font-size:24px;"
                                                                                   :for="`item_pdt_${pdt_item_i}_${pdt_i}_nota`">
                                                                                Nota
                                                                            </label>
                                                                            <span class="label-info-baixo-destaque">Nota mínima: {{
                                                                                    retornaItemDaConfiguracaoDeAcordoComId(pdt_item.item_id).nota_min
                                                                                                                    }} | Nota máxima: {{
                                                                                    retornaItemDaConfiguracaoDeAcordoComId(pdt_item.item_id).nota_max
                                                                                                                    }}</span>
                                                                        </div>

                                                                        <div class="col s12">
                                                                            <strong>Justificativa da nota</strong>

                                                                            <textarea
                                                                                style="width: 100%; min-height: 150px;"
                                                                                :id="`item_pdt_${pdt_item_i}_${pdt_i}_justificativa`"
                                                                                :maxlength="configuracao_avaliacao.quantidade_caracteres_justificativa"
                                                                                v-model="pdt_item.justificativa"
                                                                                class="browser-default"></textarea>

                                                                            <span class="right"
                                                                                  style="font-size: small;">{{
                                                                                    !pdt_item.justificativa ? 0 : pdt_item.justificativa.length
                                                                                                            }}/{{
                                                                                    configuracao_avaliacao.quantidade_caracteres_justificativa
                                                                                                            }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <!-- CONCLUSÃO DO AVALIADOR -->

                <div id="geral" class="col s12">

                    <div class="row">

                        <div class="col s12">

                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">
                                        Parecer do avaliador
                                    </h5>

                                    <div class="col s12">
                                        <textarea style="width: 100%; min-height: 250px;"
                                                  id="parecer"
                                                  :maxlength="configuracao_avaliacao.quantidade_caracteres_parecer"
                                                  v-model="avaliacao.parecer"
                                                  class="browser-default"></textarea>

                                        <span class="right" style="font-size: small;">{{
                                                !avaliacao.parecer ? 0 : avaliacao.parecer.length
                                                                                      }}/{{
                                                configuracao_avaliacao.quantidade_caracteres_parecer
                                                                                      }}</span>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>


            </div>

        </div>

        <div class="row">
            <div class="col s12">
                &nbsp;
                <button type="button"
                        class="btn waves-effect waves-light light-blue darken-2"
                        :disabled="loading || impedido"
                        @click.prevent="salva">
                    <i class="material-icons left">save</i>
                    Salvar sem enviar
                </button>

                &nbsp;
                <button type="button"
                        class="btn waves-effect waves-light indigo"
                        :disabled="loading || impedido"
                        @click.prevent="salvaEFinaliza">
                    <i class="material-icons left">send</i>
                    Salvar e enviar
                </button>

                &nbsp;
                <button type="button"
                        class="btn waves-effect waves-light red"
                        :disabled="impedido || !impedimento"
                        @click.prevent="declaraImpedimento">
                    <i class="material-icons left">block</i>
                    Declarar impedimento
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import file_uploads from "../../../utils/file_uploads";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "realizar_avaliacao",
    components: {Loading},
    props: {
        Avaliacao: {
            type: String,
            default: null,
        },
        Impedido: {
            type: String,
            default: null,
        },
        Impedimento: {
            type: String,
            default: null,
        },
        ConfiguracaoAvaliacao: {
            type: String,
            default: null,
        },
        Grupos: {
            type: String,
            default: null,
        },
        routeList: {
            type: String,
            default: null,
        },
		pEventoQtdos: { 
			type: String,
            default: null,
            required: true
		}
    },
    data() {
        return {
            avaliacao: JSON.parse(this.Avaliacao),
            configuracao_avaliacao: JSON.parse(this.ConfiguracaoAvaliacao),
            grupos: JSON.parse(this.Grupos),
            loading: false,
            itens_da_acao_nao_justificados: [],
            itens_do_pdt_nao_justificados: [],
            impedido: this.Impedido === '' ? false : JSON.parse(this.Impedido),
            impedimento: this.Impedimento === '' ? null : JSON.parse(this.Impedimento),
			eventoQtdos: JSON.parse(this.pEventoQtdos),
        }
    },
    computed: {
        listaItensParaAvaliacaoDosItensPreConfiguradosDaInscricaoEDoGrupoAvaliacaoDaAcao() {
            if (this.avaliacao.itens_da_acao === null)
                return []

            return _.filter(this.avaliacao.itens_da_acao, (item) => {
                return item.campo_referente_na_inscricao === 'itens' && _.find(this.avaliacao.inscricao.itens, (item_inscricao) => {
                    return item_inscricao.descricao === item.nome && item.grupo === 8;
                })
            })
        },

        listaItensFixosDaInscricao() {
            if (this.avaliacao.itens_da_acao === null)
                return []

            return _.filter(this.avaliacao.itens_da_acao, (item) => {
                return item.campo_referente_na_inscricao !== 'itens' && item.grupo === 8
            })
        },

        listaPlanosDeTrabalhoParaAvaliacao() {
            if (this.avaliacao.itens_do_plano_de_trabalho === null)
                return []

            return this.avaliacao.itens_do_plano_de_trabalho
        }
    },
    methods: {

        verificaSeItemDaAcaoEstaMarcadoParaPreencher(item_id) {
            return _.findIndex(this.itens_da_acao_nao_justificados, (itemId) => {
                return itemId === item_id;
            }) > -1;
        },

        verificaSeItemDoPdtEstaMarcadoParaPreencher(pdt_id, item) {
            return _.findIndex(this.itens_do_pdt_nao_justificados, (pdt) => {
                return pdt.pdt_id === pdt_id && _.findIndex(pdt.itens, (pdtItem) => {
                    return pdtItem === item
                }) > -1;
            }) > -1;
        },

        validaItensDaAcaoNaoJustificados() {
            this.itens_da_acao_nao_justificados.splice(0)

            _.forEach(this.avaliacao.itens_da_acao, (item_avaliado) => {
                const config_item = this.retornaItemDaConfiguracaoDeAcordoComId(item_avaliado.item_id)

                if (!item_avaliado.justificativa || item_avaliado.justificativa === '')
                    this.itens_da_acao_nao_justificados.push(item_avaliado.item_id);
            });

            return this.itens_da_acao_nao_justificados.length === 0
        },

        validaItensDoPdtNaoJustificados() {
            this.itens_do_pdt_nao_justificados.splice(0)

            _.forEach(this.avaliacao.itens_do_plano_de_trabalho, (pdt) => {
                let pdt_id = null;
                let itens_do_pdt = [];

                pdt.itens.forEach((item_avaliado) => {
                    const config_item = this.retornaItemDaConfiguracaoDeAcordoComId(item_avaliado.item_id)

                    if (!item_avaliado.justificativa || item_avaliado.justificativa === '') {
                        pdt_id = pdt.pdt_id
                        itens_do_pdt.push(item_avaliado.item_id)
                    }
                })

                if (pdt_id) {
                    this.itens_do_pdt_nao_justificados.push({
                        pdt_id: pdt_id,
                        itens: itens_do_pdt
                    })
                }
            });

            return this.itens_do_pdt_nao_justificados.length === 0
        },

        async salva() {

            const url = `/api/avaliacoes/salvar-temporario/${this.avaliacao.id}`

            this.loading = true;

            await this.$http.put(url, {'avaliacao': this.avaliacao}).then(response => {
                window.location.href = `${this.routeList}/?msg=${response.body.msg}`
                //Swal.fire('Sucesso!', response.body.msg, 'success')
            }, error => {
                if (error.body.hasOwnProperty('validation_errors')) {
                    Swal.fire('Ocorreu um erro!', error.body.validation_errors[0], 'error')
                } else {
                    const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                    Swal.fire({
                        title: 'Ocorreu um erro!',
                        html: exceptionMensagem,
                        footer: error.body.msg,
                        icon: 'error'
                    })
                }
            })

            this.loading = false
        },

        async salvaEFinaliza() {

            let result = await this.verificarNotaZero();
            if (result===true)
                return false;

            if (!this.validaItensDaAcaoNaoJustificados()) {
                Swal.fire('Ação inválida!', 'Na Aba de Itens da Ação tem campos de justificativa que não foram preenchidos. Por favor, corrija os itens em destaque antes de prosseguir!', 'error');
                return false;
            }

            if (!this.validaItensDoPdtNaoJustificados()) {
                Swal.fire('Ação inválida!', 'Na Aba de Itens do Plano de Trabalho tem campos de justificativa que não foram preenchidos. Por favor, corrija os itens em destaque antes de prosseguir!', 'error');
                return false;
            }

            if (!this.avaliacao.parecer || this.avaliacao.parecer === '') {
                Swal.fire('Ação inválida!', 'Na Aba de Conclusão é obrigatório informar o Parecer antes de enviar a avaliação.', 'error');
                return false;
            }

            const url = `/api/avaliacoes/salvar-e-finalizar/${this.avaliacao.id}`

            Swal.fire({
                title: 'Você tem certeza que deseja prosseguir com a operação?',
                text: "Ao enviar a avaliação o procedimento é definitivo e a mesma não poderá mais ser editada!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#525252',
                confirmButtonText: 'Sim, enviar!',
                cancelButtonText: 'Cancelar.'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.loading = true;

                    await this.$http.put(url, {'avaliacao': this.avaliacao}).then(response => {
                        window.location.href = `${this.routeList}/?msg=${response.body.msg}`
                        //Swal.fire('Sucesso!', response.body.msg, 'success')
                    }, error => {
                        if (error.body.hasOwnProperty('validation_errors')) {
                            Swal.fire('Ocorreu um erro!', error.body.validation_errors[0], 'error')
                        } else {
                            const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                            Swal.fire({
                                title: 'Ocorreu um erro!',
                                html: exceptionMensagem,
                                footer: error.body.msg,
                                icon: 'error'
                            })
                        }
                    })

                    this.loading = false
                }
            })


        },
        async verificarNotaZero() {
            let nota = false;

            // this.avaliacao.itens_do_plano_de_trabalho
            // .0.itens
            // .0.nota
            this.avaliacao.itens_do_plano_de_trabalho.forEach((plano) => {

                plano.itens.forEach((item) => {
                    if (parseFloat(item.nota) == 0) {
                        nota = true;
                    }
                });

            })

            this.avaliacao.itens_da_acao.forEach((item) => {
				if (parseFloat(item.nota) == 0 
				 && (item.justificativa != "O proponente não indicou atuação em territórios e/ou junto aos grupos vulneráveis."
				 && item.justificativa != "O proponente não indicou nenhuma política pública."
				 && item.justificativa != "O proponente não indicou nenhuma política de ação afirmativa.")) {
                    nota = true;
                }

            })

            if (nota === true) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn green waves-effect waves-light m2",
                        cancelButton: "btn red waves-effect waves-light m2"
                    },
                    buttonsStyling: true
                });
                const [confirmar] = await Promise.all([swalWithBootstrapButtons.fire({
                    title: "Confirmar nota 0?",
                    text: "Atenção, a avaliação contém um ou mais quesitos avaliados com a nota 0. Deseja prosseguir assim mesmo?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sim, salvar!",
                    cancelButtonText: "Nâo, vou corrigir!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        // swalWithBootstrapButtons.fire({
                        //     title: "Salva!",
                        //     text: "Sua avaliação foi salva.",
                        //     icon: "success"
                        // });
                    } else if (
                        /* Read more about handling dismissals below */
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Cancelado",
                            text: "Verifique as notas das avaliações e clique para enviar novamente",
                            icon: "error"
                        });
                        return true;
                    }
                })]);

                if (confirmar) return true;
            }

        },

        async declaraImpedimento() {
            const {value: justificativa} = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Informe a justificativa para se declarar impedido.',
                inputPlaceholder: 'Justificativa...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value) {
                            resolve()
                        } else {
                            resolve('É obrigatório informar a justificativa para não poder realizar a avalição!')
                        }
                    })
                },
                didOpen() {
                    const swal2Labels = document.getElementsByClassName('swal2-input-label')

                    _.forEach(swal2Labels, (item) => {
                        item.style['font-size'] = '18px';
                    })
                }
            })

            if (!justificativa) return false;

            const {value: arquivo} = await Swal.fire({
                title: 'Selecione o arquivo da justificativa',
                input: 'file',
                inputAttributes: {
                    'accept': 'application/pdf, image/*',
                    'aria-label': 'PDF ou imagem da justificativa',
                    'pai': 'avaliacao'
                },
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value) {
                            resolve()
                        } else {
                            resolve('É obrigatório informar a justificativa para não poder realizar a avalição!')
                        }
                    })
                }
            })

            if (!arquivo) return false;

            const declaracaoDeImpedimentoParaAvaliar = {
                justificativa: justificativa,
                arquivo: arquivo
            }

            const url = `/api/avaliacoes/declara-impedimento/${this.avaliacao.id}`

            Swal.fire({
                title: 'Você tem certeza que deseja declarar impedimento nessa ação?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#525252',
                confirmButtonText: 'Sim, declarar!',
                cancelButtonText: 'Não, cancelar.'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const formData = new FormData()

                    formData.append('texto_justificativa', declaracaoDeImpedimentoParaAvaliar.justificativa)
                    formData.append('arquivo_justificativa', declaracaoDeImpedimentoParaAvaliar.arquivo)

                    this.loading = true;

                    await this.$http.post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(response => {
                        window.location.href = `${this.routeList}/?msg=${response.body.msg}`
                        //Swal.fire('Sucesso!', response.body.msg, 'success')
                    }, error => {
                        if (error.body.hasOwnProperty('validation_errors')) {
                            Swal.fire('Ocorreu um erro!', error.body.validation_errors[0], 'error')
                        } else {
                            const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                            Swal.fire({
                                title: 'Ocorreu um erro!',
                                html: exceptionMensagem,
                                footer: error.body.msg,
                                icon: 'error'
                            })
                        }
                    })

                    this.loading = false
                }
            })
        },

        async inicializaItensDaAcao() {

            if (this.avaliacao.itens_da_acao == null)
                await this.insereOsItensDeAvaliacaoDaAcao()
			else {
				var itens = this.avaliacao.itens_da_acao,
					i = itens.length;
					
					while (--i >= 0)
						if (itens[i].nome === 'Relatório da ação extraído do SIGA' && this.avaliacao.inscricao.analise_tecnica.item_relatorio_acao_siga === 'nao_se_aplica') {
							itens[i].justificativa = "O relatório do proponente recebeu 'não se aplica' na análise técnica.";
							itens[i].nota = this.retornaItemDaConfiguracaoDeAcordoComId(itens[i].item_id).nota_max;
							break;
						}
			}

            if (this.avaliacao.itens_do_plano_de_trabalho == null)
                await this.insereOsItensDoPlanoDeTrabalhoNaAvaliacaoDaAcao()
        },

        retornaItemDaConfiguracaoDeAcordoComDescricao(descricao, grupo = 8) {
            return _.find(this.configuracao_avaliacao.itens_da_avaliacao, (item) => {
                return ((item.nome === descricao || item.label === descricao) && item.grupo === grupo);
            });
        },

        retornaItemDaConfiguracaoDeAcordoComId(id) {
            return _.find(this.configuracao_avaliacao.itens_da_avaliacao, (item) => {
                return item.id === id
            });
        },

        async insereOsItensDeAvaliacaoDaAcao() {
            this.avaliacao.itens_da_acao = []

            const itens_ordenados = _.orderBy(_.filter(this.configuracao_avaliacao.itens_da_avaliacao, (item) => {
                return item.campo_referente_na_inscricao === 'itens';
            }), 'id', 'asc');

            _.forEach(itens_ordenados, (item) => {

                this.adicionaItem(item)
            })

            const itens_fixos = _.filter(this.configuracao_avaliacao.itens_da_avaliacao, (item) => {
                return item.campo_referente_na_inscricao !== 'itens' && item.grupo === 8;
            })

            _.forEach(itens_fixos, (item) => {

                this.adicionaItem(item)
            })
        },

        adicionaItem(item) {

            let justificativa = null;
            let nota = item.nota_min;

            if (item.campo_referente_na_inscricao === 'acao_atgv' && !this.avaliacao.inscricao.acao_atgv) {
                justificativa = 'O proponente não indicou atuação em territórios e/ou junto aos grupos vulneráveis.';
                nota = 0
            } else if (item.campo_referente_na_inscricao === 'acao_afirmativa' && !this.avaliacao.inscricao.acao_afirmativa) {
                justificativa = 'O proponente não indicou nenhuma política de ação afirmativa.';
                nota = 0
			} else if (item.campo_referente_na_inscricao === 'acao_politicas_publicas' && !this.avaliacao.inscricao.acao_politicas_publicas) {
                justificativa = 'O proponente não indicou nenhuma política pública.';
                nota = 0	
            } else if (item.nome === 'Relatório da ação extraído do SIGA' && this.avaliacao.inscricao.analise_tecnica.item_relatorio_acao_siga === 'nao_se_aplica') {
                justificativa = "O relatório do proponente recebeu 'não se aplica' na análise técnica.";
                nota = item.nota_max;
            }
			
			if (this.avaliacao.inscricao.acao.modalidade == item.modalidade)
				this.avaliacao.itens_da_acao.push({
					item_id: item.id,
					nome: item.nome,
					label: item.label,
					nota: nota,
					justificativa: justificativa,
					grupo: item.grupo,
					campo_referente_na_inscricao: item.campo_referente_na_inscricao,
					modalidade: item.modalidade
				})
        },

        async insereOsItensDoPlanoDeTrabalhoNaAvaliacaoDaAcao() {
            this.avaliacao.itens_do_plano_de_trabalho = []

            if (this.avaliacao.inscricao.repetiu_pdt_bolsista) {
                this.avaliacao.inscricao.planos_de_trabalho.forEach((pdt, index) => {
                    this.avaliacao.itens_do_plano_de_trabalho.push({
                        pdt_id: pdt.id,
                        itens: [],
                    })
                });
            } else {
                _.forEach(this.avaliacao.inscricao.planos_de_trabalho, (pdt) => {

                    this.avaliacao.itens_do_plano_de_trabalho.push({
                        pdt_id: pdt.id,
                        itens: [],
                    })
                })
            }

            _.forEach(this.avaliacao.itens_do_plano_de_trabalho, (pdt) => {
                //grupo = 9 = PLANO_TRABALHO
                const itens_ordenados = _.orderBy(_.filter(this.configuracao_avaliacao.itens_da_avaliacao, (item) => {
                    return item.campo_referente_na_inscricao === 'planos_de_trabalho' && item.grupo === 9;
                }), 'id', 'asc');

				itens_ordenados.forEach((item) => {
					if (this.avaliacao.inscricao.acao.modalidade == item.modalidade)	
						pdt.itens.push({
							item_id: item.id,
							nome: item.nome,
							label: item.label,
							nota: item.nota_min,
							justificativa: null,
							grupo: item.grupo,
							modalidade: item.modalidade,
							campo_referente_na_inscricao: item.campo_referente_na_inscricao,
						})
				})

            })
        },

        // Grupos: 8 - Inscrição, 9 - Plano de Trabalho
        selecionaItemDaInscricao(item_configuracao, grupo = 8, pdt_id = null) {
            let item = null;

            if (grupo === 8) {
                item = _.find(this.avaliacao.inscricao.itens, (item_inscricao) => {
                    return item_inscricao.modalidade == item_configuracao.modalidade && item_inscricao.descricao === item_configuracao.nome;
                })
            } else if (grupo === 9) {
                const plano_trabalho = _.find(this.avaliacao.inscricao.planos_de_trabalho, (pdt) => {
                    return pdt.id === pdt_id
                })

                item = _.find(plano_trabalho.itens, (item_inscricao) => {
                    return item_inscricao.modalidade == item_configuracao.modalidade && item_inscricao.descricao === item_configuracao.nome;
                })
            }

            return item;
        },

        // Grupos: 8 - Inscrição, 9 - Plano de Trabalho
        retornaRespostaDoItemDaInscricao(item_configurado, grupo = 8, pdt_id = null) {
            const item = this.selecionaItemDaInscricao(item_configurado, grupo, pdt_id)

            if (item && item.resposta)
                return item.resposta
            else
                return null;
        },

        retornaAnexoDeItemDaInscricao(item_configurado) {
            const item = this.selecionaItemDaInscricao(item_configurado)

            return _.find(this.avaliacao.inscricao.anexos, (anexo) => {
                return anexo.id = item.anexo_id
            })
        },

        linkParaDownload(anexo) {
            return file_uploads.linkParaDownloadDeAnexosEmGeral(anexo)
        },

        selecionaPlanoDeTrabalho(pdt_id) {
            return _.find(this.avaliacao.inscricao.planos_de_trabalho, (pdt) => {
                return pdt.id === pdt_id;
            })
        },

        validaCampo(item, nota_minima, nota_maxima) {

            if (isNaN(item.nota) || (parseFloat(item.nota) < parseFloat(nota_minima) || parseFloat(item.nota) > parseFloat(nota_maxima)))
                item.nota = nota_minima;

            return true;
        },

        cancelaDigitacaoNasCaixasDeTextoDasNotas(e) {

        },
        formatarData(data) {
            var objeto = new Date(data);
            return objeto.getUTCDate() + '/' + (objeto.getUTCMonth() + 1) + '/' + objeto.getUTCFullYear();
        }
    },
    mounted() {
        this.inicializaItensDaAcao()
    }
}
</script>

<style scoped>
.justificativaNaoPreenchida {
    border: 1px solid red;
}

input.notas {
    cursor: default;
    /*when hover it default pointer*/
    color: transparent;
    /*make blinking cursor disappear*/
    /*but it will make to text disappear*/
    text-shadow: 0px 0px black;
    /*when it disappear add text shadow to black*/
}
</style>
